import { useSyncExternalStore } from 'react';
import { getBootstrapState, subscribeBootstrapState, type BootstrapState } from './bootstrap';

/** React binding for the bootstrap engine — re-renders on every state change. */
export function useBootstrapState(): BootstrapState {
  return useSyncExternalStore(subscribeBootstrapState, getBootstrapState, getBootstrapState);
}
